(ns dashboard.components.login
  (:require
   [re-frame.core :as re-frame]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen]]
   [dashboard.events.auth :as auth]
   [dashboard.events.auth0 :as auth0]))

(defn form []
  (let [login (atom {:email "" :password ""})]
    (fn []
      [:div.max-w-md.w-full.space-y-8
       [:div
        [:div.flex.items-center.justify-center
         [:div
          [:span.sr-only
           (listen ::subs/company-name)]
          [:img.mx-auto.h-12.w-auto
           {:src (listen ::subs/logo-reversed)}]
          [:h2.mt-6.text-center.text-3xl.font-extrabold.text-gray-900
           "Sign in to your account"]]]]
       [:div.mt-8.space-y-6
        [:input {:value "true" :name "remember" :type "hidden"}]
        [:div.rounded-md.shadow-sm.-space-y-px
         [:div
          [:label.sr-only
           {:for "email-address"}
           "Email address"]
          [:input#email-address.appearance-none.rounded-none.relative.block.w-full.px-3.py-2.border.border-gray-300.placeholder-gray-500.text-gray-900.rounded-t-md.focus:outline-none.focus:ring-primary-500.focus:border-primary-500.focus:z-10.sm:text-sm
           {:placeholder "Email address"
            :required "required"
            :auto-complete "email"
            :type "email"
            :name "email"}]]
         [:div
          [:label.sr-only
           {:for "password"}
           "Password"]
          [:input#password.appearance-none.rounded-none.relative.block.w-full.px-3.py-2.border.border-gray-300.placeholder-gray-500.text-gray-900.rounded-b-md.focus:outline-none.focus:ring-primary-500.focus:border-primary-500.focus:z-10.sm:text-sm
           {:placeholder "Password"
            :required "required"
            :auto-complete "current-password"
            :type "password"
            :name "password"}]]]
        [:div.flex.items-center.justify-between
         [:div.flex.items-center
          [:input#remember-me.h-4.w-4.text-primary-600.focus:ring-primary-500.border-gray-300.rounded
           {:type "checkbox" :name "remember-me"}]
          [:label.ml-2.block.text-sm.text-gray-900
           {:for "remember-me"}
           "Remember me"]]
         [:div.text-sm
          [:a.font-medium.text-primary-600.hover:text-primary-500
           {:href "#"}
           "Forgot your password?"]]]
        [:div
         [:button.group.relative.w-full.flex.justify-center.py-2.px-4.border.border-transparent.text-sm.font-medium.rounded-md.text-white.bg-primary-600.hover:bg-primary-700.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500
          {:type "submit"
           :on-click #(re-frame/dispatch [::auth/do-login])}
          [:span.absolute.left-0.inset-y-0.flex.items-center.pl-3
           [:svg.h-5.w-5.text-primary-500.group-hover:text-primary-400
            {:aria-hidden "true"
             :fill "currentColor"
             :viewBox "0 0 20 20"}
            [:path
             {:clip-rule "evenodd"
              :d "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
              :fill-rule "evenodd"}]]]
          "Sign in"]]]])))

(defn auth0-link []
  (let [loading? (listen :auth0/loading?)
        error-stage (listen :auth0/error-stage)
        error-message (listen :auth0/error-message)
        authenticated? (boolean (listen :auth0/user-data))]
    [:div.max-w-md.w-full.space-y-8
     [:div
      [:div.flex.items-center.justify-center
       [:div
        [:span.sr-only
         (listen ::subs/company-name)]
        [:img.mx-auto.h-60.w-auto
         {:src (listen ::subs/logo-reversed)}]
        [:h2.mt-6.text-center.text-3xl.font-extrabold.text-gray-900
         "Sign in to your account"]]]]
     [:div.mt-8.space-y-6
      [:div
       [:button.group.relative.w-full.flex.justify-center.py-2.px-4.border.border-transparent.text-sm.font-medium.rounded-md.text-white.bg-primary-600.hover:bg-primary-700.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500
        {:type "submit"
         :on-click #(re-frame/dispatch (if authenticated?
                                         [::auth0/logout]
                                         [::auth0/login :route.home/home]))}
        [:span.absolute.left-0.inset-y-0.flex.items-center.pl-3
         [:svg.h-5.w-5.text-primary-500.group-hover:text-primary-400
          {:aria-hidden "true"
           :fill "currentColor"
           :viewBox "0 0 20 20"}
          [:path
           {:clip-rule "evenodd"
            :d "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            :fill-rule "evenodd"}]]]
        (if authenticated?
          "Sign out"
          "Sign in")]]]]))
